// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__21M1n","dragIcon":"Choice_dragIcon__22G4x","left":"Choice_left__3kg9g","input":"Choice_input__3lKdk"};